import { autoinject } from "aurelia-dependency-injection";
import { ClientSideValidator, EntityValidationsService } from "../../../../../../client-validation-system/validations-service";
import { ValidationActivation, ValidationTypeEnum } from "../../../../../../client-validation-system/validations.models";
import { EmailRecipientTypeEnum } from "../../../../../../models/vetting/vetting.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { PortFormModel } from "../../models/ports-and-terminals.models";
import { PortsAndTerminalsService } from "../../services/ports-and-terminals.service";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";

@autoinject
export class RequestForFormsDialog {

    vesselImoNumber: string;
    vesselName: string;
    portSKey: number;
    vesselPortCallId: number;
    vesselBKey: number;
    onSave: () => void;
    validatorEmails: ClientSideValidator;
    emails: { email: string; emailRecipientTypeId: number; }[] = [{
        email: "",
        emailRecipientTypeId: EmailRecipientTypeEnum.To
    }];
    forms: PortFormModel[] = [];
    formsLoading: boolean = true;

    constructor(private dialogClientService: DialogClientService,
        private entityValidationsService: EntityValidationsService,
        private portsAndTerminalsService: PortsAndTerminalsService,
        private notificationClientService: NotificationClientService) { }

    activate(model: { portSKey: number, vesselBKey: number, vesselPortCallId: number, vesselName: string, vesselImoNumber: string, onSave: () => void }) {
        this.vesselImoNumber = model.vesselImoNumber;
        this.vesselName = model.vesselName;
        this.portSKey = model.portSKey;
        this.vesselPortCallId = model.vesselPortCallId;
        this.vesselBKey = model.vesselBKey;
        this.onSave = model.onSave;
        this.portsAndTerminalsService.getPortForms(model.portSKey).then(forms => {
            this.forms = forms;
            this.formsLoading = false;
        });
    }

    private setValidator() {

        const rulesHolderEmails = {
            activation: ValidationActivation.Always,
            entityName: "Request Forms Emails",
            isCollection: true,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: "Your email is required",
                parameters: null, property: "email",
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Email is not in correct format",
                parameters: null, property: "email",
                validationType: ValidationTypeEnum.Email
            }]
        };
        this.validatorEmails = this.entityValidationsService.getValidator(this.emails, rulesHolderEmails);
    }

    addEmail() {
        this.emails.push({
            email: "",
            emailRecipientTypeId: EmailRecipientTypeEnum.To
        });
    }

    removeEmail(index: number) {
        this.emails.splice(index, 1);
    }

    async close() {
        await this.dialogClientService.hide();
    }

    async openAllSubmittedFormsDialog() {
        await this.close();

        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.PortCallFormsDialog,
            {
                vesselSKey: this.vesselBKey,
                vesselName: this.vesselName,
                vesselImoNumber: this.vesselImoNumber
            }, true, false, false, "right");
    }

    submit() {
        return new Promise<void>((resolve, reject) => {
            this.setValidator();
            if (this.forms.every(x => !x.isSelected)) {
                this.notificationClientService.show("At least 1 form must be selected!", "", NotificationType.Error);
                reject();
                return;
            }
            this.validatorEmails.validate().then(validationResponse => {
                if (validationResponse.valid) {
                    this.portsAndTerminalsService.createVesselForms({
                        vesselBKey: this.vesselBKey,
                        vesselPortCallId: this.vesselPortCallId,
                        formIds: this.forms.filter(x => x.isSelected).map(x => x.formSKey),
                        emails: this.emails
                    })
                        .then(() => {
                            this.notificationClientService.show("Forms requested successfully", null, NotificationType.Success);
                            this.close();
                            if (this.onSave) {
                                this.onSave();
                            }
                            resolve();
                        })
                        .catch(e => reject(e));
                }
                else {
                    resolve();
                }
            });
        })
    }
}
